import {BillingDataModel} from '../entities/entities'

// TODO:: This should be removed and replaced with the new API response - Already done on patientBillingReport.tsx
export interface RawBillingItem {
  id: number
  uuid: string
  full_name: string
  email: string
  phone_number: string
  care_minutes: string
  month_year: string
  readings: number
  status: number
  dob?: string
  cycle_start?: string
  cycle_end?: string
  cpt_99445?: boolean
  cpt_99453?: boolean
  cpt_99454?: boolean
  cpt_99457?: boolean
  cpt_99458?: number
  cpt_99470?: boolean
  first_name?: string
  last_name?: string
  DeviceAllocations?: Array<{
    id: number
    device_id: number
    devices_assigned_date: string
    devices_de_allocation_date: string | null
    doctor_id: number
    patient_id: number
    Device: {id: number; name: string; imei: string}
  }>
}

export function mapRawToBillingData(item: RawBillingItem): BillingDataModel {
  return {
    full_name: item.full_name,
    patient_id: item.id,
    uuid: item.uuid,
    care_minutes: item.care_minutes,
    month_year: item.month_year,
    readings: item.readings,
    cycle_start: item.cycle_start,
    cycle_end: item.cycle_end,
    cpt_99445: item.cpt_99445,
    cpt_99453: item.cpt_99453,
    cpt_99454: item.cpt_99454,
    cpt_99457: item.cpt_99457,
    cpt_99458: item.cpt_99458,
    cpt_99470: item.cpt_99470,
    status: item.status,
    Patient: {
      id: item.id,
      uuid: item.uuid,
      email: item.email,
      phone_number: item.phone_number,
      status: item.status,
      first_name: item.first_name,
      last_name: item.last_name,
      dob: item.dob,
    },
  }
}
